import { getMsalIdToken, handleTokenExpiration } from 'Services/MsalTokenService';
import F2WCustomLogger from 'Services/F2WCustomLogger';

class AuthInterceptorService {
  static setupRequestInterceptor(axiosInstance) {
    return axiosInstance.interceptors.request.use(
      async (config) => {
        try {
          const token = await getMsalIdToken();
          config.headers.Authorization = `Bearer ${token}`;
        } catch (error) {
          F2WCustomLogger.error('Failed to get token for request', error, { service: 'AuthInterceptor' });
          throw error;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  static setupResponseInterceptor(axiosInstance) {
    return axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        // Only attempt token renewal if:
        // 1. Status is 401
        // 2. Request hasn't been retried yet
        // 3. Request has Authorization header (meaning it was authenticated)
        if (error.response?.status === 401 && !originalRequest._retry && originalRequest.headers?.Authorization) {
          originalRequest._retry = true;

          try {
            F2WCustomLogger.log('Authentication failed, attempting token renewal', { service: 'AuthInterceptor' });
            const renewed = await handleTokenExpiration();

            if (renewed) {
              const newToken = await getMsalIdToken();
              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              return axiosInstance(originalRequest);
            }
          } catch (renewError) {
            F2WCustomLogger.error('Token renewal failed', renewError, { service: 'AuthInterceptor' });
          }
        }

        return Promise.reject(error);
      }
    );
  }
}

export default AuthInterceptorService;
